module.exports = __webpack_public_path__ + "img/tuki_yes.e696d0f4.png";